export const environment = {
  production: false,
  sandbox: false,
  appUrl: 'https://dev.returns.deliverysolutions.co/',
  serverUrl: 'https://development.customer-api.deliverysolutions.co/api/v2/',
  streamServiceUrl: 'https://dev.streaming.deliverysolutions.co/stream/v2',
  googleMapsAPIKey: '',
  googleTagmanagerID: 'GTM-PM5TQLT',
  awsConfig: {
    fileStorage: {
      bucket: 'https://development.files.deliverysolutions.co',
    },
  },
  serviceWorkerEnabled: true,
  checkUpdateInterval: 600000,
  env: 'dev',
  googleMapsApiKeyDecryptionPassphrase: 'sdcWq6cFjq0NLGX'
};
